import {
  message,
  PageHeader,
  Spin,
  Space,
  Row,
  Col,
  Statistic,
  Card,
  Tag,
  Divider,
} from "antd";
import {
  BankOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  FundProjectionScreenOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  round2Decimals,
  DatePickerItem,
  dineroDisabledMask,
  TableItem,
  ButtonItem,
  ErrorItem,
} from "../../../../Components/Items";
import * as XLSXStyle from "xlsx-js-style";
import moment from "moment";
import "moment/locale/es";
import { ResponsiveBar } from "@nivo/bar";
import reporteDeFlujoDeTesorefiaPdf from "../../../../Pdf/reporteDeFlujoDeTesorefiaPdf";
import reporteFlujoDeTesorefiaPresentacionPdf from "../../../../Pdf/reporteFlujoDeTesorefiaPresentacionPdf";

moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

class ReporteFlujoDeTesorefia extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    dataReporte: null,
    bancos: [],
    diasFlujo: [],
    dataGrafico: [],
  };

  atras() {
    this.props.history.goBack();
  }

  componentDidMount() {
    this.consultarReporte({
      fechaFinal: moment().add(30, "days"),
    });
  }

  consultarReporte(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesFinancieros/reporteFlujoDeTesorefia",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.crearGrafico(res.data.dias);
          this.setState({
            dataReporte: res.data,
            bancos: res.data.bancos || [],
            diasFlujo: res.data.dias || [],
          });
        } else {
          message.error("Ha sucedido un error y no se cargó bien el reporte");
        }
        this.setState({ loading: false });
      });
  }

  crearGrafico(dias) {
    // La fila "VENCIDAS" se omite de la gráfica (no tiene fecha real)
    const grafico = (dias || [])
      .filter((dia) => dia.fecha !== "VENCIDAS")
      .map((dia) => ({
        Fecha: moment(dia.fecha, "YYYY-MM-DD").format("DD/MM"),
        "Por Cobrar": round2Decimals(dia.porCobrar),
        "Por Pagar": round2Decimals(-dia.porPagar),
        "Saldo Final": round2Decimals(dia.saldoFinal),
      }));
    this.setState({ dataGrafico: grafico });
  }

  descargarExcel() {
    // ── Paleta BIWO ────────────────────────────────────────────────────────────
    const BIWO      = "00BFD6";
    const BIWO_DARK = "007A8A";
    const ALT       = "F5FBFC";
    const TOTAL_BG  = "E6F7FF";
    const ORANGE_BG = "FFF7E6";
    const GREEN     = "237804";
    const RED_C     = "A8071A";
    const BLUE      = "0050B3";
    const VEN_TEXT  = "AD4E00";
    const MONEY     = '"$"#,##0.00';

    const border = {
      top:    { style: "thin", color: { auto: 1 } },
      bottom: { style: "thin", color: { auto: 1 } },
      left:   { style: "thin", color: { auto: 1 } },
      right:  { style: "thin", color: { auto: 1 } },
    };

    // ── Estilos base ───────────────────────────────────────────────────────────
    const titleSt = {
      font: { bold: true, color: { rgb: "FFFFFF" }, sz: 14 },
      fill: { fgColor: { rgb: BIWO_DARK } },
      alignment: { horizontal: "center", vertical: "center" },
      border,
    };
    const infoSt = {
      font: { sz: 10, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: BIWO } },
      alignment: { horizontal: "center" },
      border,
    };
    const sectionSt = {
      font: { bold: true, color: { rgb: "FFFFFF" }, sz: 11 },
      fill: { fgColor: { rgb: BIWO } },
      alignment: { horizontal: "center", vertical: "center" },
      border,
    };
    const headerSt = {
      font: { bold: true, color: { rgb: "FFFFFF" }, sz: 10 },
      fill: { fgColor: { rgb: BIWO } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border,
    };
    const kpiLblSt = {
      font: { bold: true, color: { rgb: "FFFFFF" }, sz: 9 },
      fill: { fgColor: { rgb: BIWO_DARK } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border,
    };
    const kpiValSt = (rgb) => ({
      font: { bold: true, sz: 13, color: { rgb } },
      fill: { fgColor: { rgb: "F0FEFF" } },
      alignment: { horizontal: "center", vertical: "center" },
      numFmt: MONEY,
      border,
    });
    const cellSt = (alt) => ({
      font: { sz: 10 },
      fill: { fgColor: { rgb: alt ? ALT : "FFFFFF" } },
      alignment: { horizontal: "left" },
      border,
    });
    const numSt = (alt, rgb) => ({
      font: { sz: 10, ...(rgb ? { color: { rgb } } : {}) },
      fill: { fgColor: { rgb: alt ? ALT : "FFFFFF" } },
      alignment: { horizontal: "right" },
      numFmt: MONEY,
      border,
    });
    const vCellSt = {
      font: { bold: true, sz: 10, color: { rgb: VEN_TEXT } },
      fill: { fgColor: { rgb: ORANGE_BG } },
      alignment: { horizontal: "left" },
      border,
    };
    const vNumSt = (rgb) => ({
      font: { bold: true, sz: 10, color: { rgb: rgb || VEN_TEXT } },
      fill: { fgColor: { rgb: ORANGE_BG } },
      alignment: { horizontal: "right" },
      numFmt: MONEY,
      border,
    });
    const totalLblSt = {
      font: { bold: true, sz: 10 },
      fill: { fgColor: { rgb: TOTAL_BG } },
      alignment: { horizontal: "left" },
      border,
    };
    const totalNumSt = (rgb) => ({
      font: { bold: true, sz: 10, ...(rgb ? { color: { rgb } } : {}) },
      fill: { fgColor: { rgb: TOTAL_BG } },
      alignment: { horizontal: "right" },
      numFmt: MONEY,
      border,
    });

    const emp = (st) => ({ v: "", t: "s", s: st });

    // ── Datos comunes ──────────────────────────────────────────────────────────
    const saldoTotal    = this.state.bancos.reduce((s, b) => s + (b.saldo || 0), 0);
    const { totales = {}, empresa = {}, fechaFinal } = this.state.dataReporte || {};
    const empresaNombre = empresa.nombreComercial
      || (empresa.persona ? empresa.nombre : `${empresa.nombre || ""} ${empresa.apellidoPaterno || ""}`.trim());
    const periodoStr    = `Hoy — ${moment(fechaFinal).locale("es").format("LL")}`;
    const saldoProy     = totales.saldoFinalProyectado || 0;

    const workbook = XLSXStyle.utils.book_new();

    // ──────────────────────────────────────────────────────────────────────────
    // HOJA 1: RESUMEN EJECUTIVO
    // ──────────────────────────────────────────────────────────────────────────
    {
      const rows = [];
      const merges = [];
      const M = (r, c0, c1) => merges.push({ s: { r, c: c0 }, e: { r, c: c1 } });
      const NC = 3; // columnas 0-3

      rows.push([{ v: "FLUJO DE EFECTIVO — TESORERÍA", t: "s", s: titleSt }, emp(titleSt), emp(titleSt), emp(titleSt)]);
      M(0, 0, NC);

      rows.push([{ v: empresaNombre, t: "s", s: infoSt }, emp(infoSt), emp(infoSt), emp(infoSt)]);
      M(1, 0, NC);

      rows.push([{ v: periodoStr, t: "s", s: infoSt }, emp(infoSt), emp(infoSt), emp(infoSt)]);
      M(2, 0, NC);

      const gap = [emp({ border: {} }), emp({ border: {} }), emp({ border: {} }), emp({ border: {} })];
      rows.push(gap);

      // KPIs
      rows.push([
        { v: "SALDO EN BANCOS",       t: "s", s: kpiLblSt },
        { v: "TOTAL POR COBRAR",      t: "s", s: kpiLblSt },
        { v: "TOTAL POR PAGAR",       t: "s", s: kpiLblSt },
        { v: "SALDO FINAL PROYECTADO",t: "s", s: kpiLblSt },
      ]);
      rows.push([
        { v: round2Decimals(saldoTotal),                  t: "n", s: kpiValSt(BIWO_DARK) },
        { v: round2Decimals(totales.totalPorCobrar || 0), t: "n", s: kpiValSt(GREEN) },
        { v: round2Decimals(totales.totalPorPagar  || 0), t: "n", s: kpiValSt(RED_C) },
        { v: round2Decimals(saldoProy),                   t: "n", s: kpiValSt(saldoProy >= saldoTotal ? BLUE : RED_C) },
      ]);

      rows.push(gap);

      // Sección bancos
      rows.push([{ v: "SALDO ACTUAL EN BANCOS", t: "s", s: sectionSt }, emp(sectionSt), emp(sectionSt), emp(sectionSt)]);
      M(rows.length - 1, 0, NC);

      rows.push([
        { v: "Banco",        t: "s", s: headerSt },
        { v: "Cuenta",       t: "s", s: headerSt },
        { v: "Moneda",       t: "s", s: headerSt },
        { v: "Saldo Actual", t: "s", s: headerSt },
      ]);

      this.state.bancos.forEach((b, i) => {
        const alt = i % 2 === 1;
        rows.push([
          { v: b.banco,                    t: "s", s: cellSt(alt) },
          { v: b.nombre,                   t: "s", s: cellSt(alt) },
          { v: b.moneda,                   t: "s", s: cellSt(alt) },
          { v: round2Decimals(b.saldo),    t: "n", s: numSt(alt) },
        ]);
      });

      const tR = rows.length;
      rows.push([
        { v: "TOTAL EN BANCOS", t: "s", s: totalLblSt },
        emp(totalLblSt),
        emp(totalLblSt),
        { v: round2Decimals(saldoTotal), t: "n", s: totalNumSt() },
      ]);
      M(tR, 0, 2);

      const ws = XLSXStyle.utils.aoa_to_sheet(rows);
      ws["!merges"] = merges;
      ws["!cols"]   = [{ wch: 22 }, { wch: 32 }, { wch: 12 }, { wch: 22 }];
      ws["!rows"]   = [{ hpt: 28 }, { hpt: 18 }, { hpt: 18 }, { hpt: 8 }, { hpt: 24 }, { hpt: 30 }];
      XLSXStyle.utils.book_append_sheet(workbook, ws, "Resumen Ejecutivo");
    }

    // ──────────────────────────────────────────────────────────────────────────
    // HOJA 2: FLUJO POR DÍA
    // ──────────────────────────────────────────────────────────────────────────
    {
      const rows = [];
      const merges = [];
      const M = (r, c0, c1) => merges.push({ s: { r, c: c0 }, e: { r, c: c1 } });

      rows.push([
        { v: "PROYECCIÓN DIARIA DE TESORERÍA", t: "s", s: titleSt },
        emp(titleSt), emp(titleSt), emp(titleSt), emp(titleSt),
      ]);
      M(0, 0, 4);

      rows.push([
        { v: "Fecha",             t: "s", s: headerSt },
        { v: "Saldo Inicial",     t: "s", s: headerSt },
        { v: "Por Cobrar (CXC)",  t: "s", s: headerSt },
        { v: "Por Pagar (CXP)",   t: "s", s: headerSt },
        { v: "Saldo Final",       t: "s", s: headerSt },
      ]);

      let totCobrar = 0, totPagar = 0, lastSF = 0;

      this.state.diasFlujo.forEach((d, i) => {
        if (d.fecha === "VENCIDAS") {
          rows.push([
            { v: "VENCIDAS (anteriores a hoy)", t: "s", s: vCellSt },
            { v: round2Decimals(d.saldoInicial), t: "n", s: vNumSt() },
            { v: round2Decimals(d.porCobrar),    t: "n", s: vNumSt(GREEN) },
            { v: round2Decimals(d.porPagar),     t: "n", s: vNumSt(RED_C) },
            { v: round2Decimals(d.saldoFinal),   t: "n", s: vNumSt() },
          ]);
        } else {
          const alt = i % 2 === 0;
          const sf  = d.saldoFinal || 0;
          totCobrar += d.porCobrar || 0;
          totPagar  += d.porPagar  || 0;
          lastSF     = sf;
          rows.push([
            { v: moment(d.fecha, "YYYY-MM-DD").format("DD/MM/YYYY"), t: "s", s: cellSt(alt) },
            { v: round2Decimals(d.saldoInicial), t: "n", s: numSt(alt) },
            { v: round2Decimals(d.porCobrar),    t: "n", s: numSt(alt, d.porCobrar > 0 ? GREEN : undefined) },
            { v: round2Decimals(d.porPagar),     t: "n", s: numSt(alt, d.porPagar  > 0 ? RED_C : undefined) },
            { v: round2Decimals(sf),             t: "n", s: numSt(alt, sf >= 0 ? BLUE : RED_C) },
          ]);
        }
      });

      const tR = rows.length;
      rows.push([
        { v: "TOTALES DEL PERÍODO", t: "s", s: totalLblSt },
        emp(totalLblSt),
        { v: round2Decimals(totCobrar), t: "n", s: totalNumSt(GREEN) },
        { v: round2Decimals(totPagar),  t: "n", s: totalNumSt(RED_C) },
        { v: round2Decimals(lastSF),    t: "n", s: totalNumSt(lastSF >= 0 ? BLUE : RED_C) },
      ]);
      M(tR, 0, 1);

      const ws = XLSXStyle.utils.aoa_to_sheet(rows);
      ws["!merges"] = merges;
      ws["!cols"]   = [{ wch: 26 }, { wch: 18 }, { wch: 20 }, { wch: 18 }, { wch: 20 }];
      ws["!freeze"] = { xSplit: 0, ySplit: 2 };
      XLSXStyle.utils.book_append_sheet(workbook, ws, "Flujo por Día");
    }

    // ──────────────────────────────────────────────────────────────────────────
    // HOJA 3: DETALLE CXC
    // ──────────────────────────────────────────────────────────────────────────
    {
      const rows = [];
      const merges = [];
      const M = (r, c0, c1) => merges.push({ s: { r, c: c0 }, e: { r, c: c1 } });

      const cxcTitleSt  = { ...titleSt,  fill: { fgColor: { rgb: "135200" } } };
      const cxcHeaderSt = { ...headerSt, fill: { fgColor: { rgb: "237804" } } };

      rows.push([
        { v: "DETALLE DE CUENTAS POR COBRAR", t: "s", s: cxcTitleSt },
        emp(cxcTitleSt), emp(cxcTitleSt), emp(cxcTitleSt), emp(cxcTitleSt),
      ]);
      M(0, 0, 4);

      rows.push([
        { v: "Fecha Vencimiento", t: "s", s: cxcHeaderSt },
        { v: "Cliente",           t: "s", s: cxcHeaderSt },
        { v: "Folio",             t: "s", s: cxcHeaderSt },
        { v: "Monto a Cobrar",    t: "s", s: cxcHeaderSt },
        { v: "Días Vencido",      t: "s", s: cxcHeaderSt },
      ]);

      let totCXC = 0;
      this.state.diasFlujo.forEach((dia) => {
        (dia.cxcDetalle || []).forEach((item, i) => {
          const esVen = dia.fecha === "VENCIDAS";
          const alt   = !esVen && i % 2 === 1;
          const label = esVen ? "VENCIDA" : moment(dia.fecha, "YYYY-MM-DD").format("DD/MM/YYYY");
          totCXC += item.monto || 0;
          rows.push([
            { v: label,                       t: "s", s: esVen ? vCellSt : cellSt(alt) },
            { v: item.clienteNombre,          t: "s", s: esVen ? vCellSt : cellSt(alt) },
            { v: item.folio,                  t: "s", s: esVen ? vCellSt : cellSt(alt) },
            { v: round2Decimals(item.monto),  t: "n", s: esVen ? vNumSt(GREEN) : numSt(alt, GREEN) },
            { v: item.diasVencido,            t: "n", s: esVen ? vCellSt : cellSt(alt) },
          ]);
        });
      });

      if (rows.length > 2) {
        const tR = rows.length;
        rows.push([
          { v: "TOTAL POR COBRAR", t: "s", s: totalLblSt },
          emp(totalLblSt), emp(totalLblSt),
          { v: round2Decimals(totCXC), t: "n", s: totalNumSt(GREEN) },
          emp(totalLblSt),
        ]);
        M(tR, 0, 2);
      }

      const ws = XLSXStyle.utils.aoa_to_sheet(rows);
      ws["!merges"] = merges;
      ws["!cols"]   = [{ wch: 18 }, { wch: 34 }, { wch: 14 }, { wch: 18 }, { wch: 14 }];
      ws["!freeze"] = { xSplit: 0, ySplit: 2 };
      XLSXStyle.utils.book_append_sheet(workbook, ws, "Detalle CXC");
    }

    // ──────────────────────────────────────────────────────────────────────────
    // HOJA 4: DETALLE CXP
    // ──────────────────────────────────────────────────────────────────────────
    {
      const rows = [];
      const merges = [];
      const M = (r, c0, c1) => merges.push({ s: { r, c: c0 }, e: { r, c: c1 } });

      const cxpTitleSt  = { ...titleSt,  fill: { fgColor: { rgb: "820014" } } };
      const cxpHeaderSt = { ...headerSt, fill: { fgColor: { rgb: "A8071A" } } };

      rows.push([
        { v: "DETALLE DE CUENTAS POR PAGAR", t: "s", s: cxpTitleSt },
        emp(cxpTitleSt), emp(cxpTitleSt), emp(cxpTitleSt), emp(cxpTitleSt),
      ]);
      M(0, 0, 4);

      rows.push([
        { v: "Fecha Vencimiento", t: "s", s: cxpHeaderSt },
        { v: "Proveedor",         t: "s", s: cxpHeaderSt },
        { v: "Folio",             t: "s", s: cxpHeaderSt },
        { v: "Monto a Pagar",     t: "s", s: cxpHeaderSt },
        { v: "Días Vencido",      t: "s", s: cxpHeaderSt },
      ]);

      let totCXP = 0;
      this.state.diasFlujo.forEach((dia) => {
        (dia.cxpDetalle || []).forEach((item, i) => {
          const esVen = dia.fecha === "VENCIDAS";
          const alt   = !esVen && i % 2 === 1;
          const label = esVen ? "VENCIDA" : moment(dia.fecha, "YYYY-MM-DD").format("DD/MM/YYYY");
          totCXP += item.monto || 0;
          rows.push([
            { v: label,                       t: "s", s: esVen ? vCellSt : cellSt(alt) },
            { v: item.proveedorNombre,        t: "s", s: esVen ? vCellSt : cellSt(alt) },
            { v: item.folio,                  t: "s", s: esVen ? vCellSt : cellSt(alt) },
            { v: round2Decimals(item.monto),  t: "n", s: esVen ? vNumSt(RED_C) : numSt(alt, RED_C) },
            { v: item.diasVencido,            t: "n", s: esVen ? vCellSt : cellSt(alt) },
          ]);
        });
      });

      if (rows.length > 2) {
        const tR = rows.length;
        rows.push([
          { v: "TOTAL POR PAGAR", t: "s", s: totalLblSt },
          emp(totalLblSt), emp(totalLblSt),
          { v: round2Decimals(totCXP), t: "n", s: totalNumSt(RED_C) },
          emp(totalLblSt),
        ]);
        M(tR, 0, 2);
      }

      const ws = XLSXStyle.utils.aoa_to_sheet(rows);
      ws["!merges"] = merges;
      ws["!cols"]   = [{ wch: 18 }, { wch: 34 }, { wch: 14 }, { wch: 18 }, { wch: 14 }];
      ws["!freeze"] = { xSplit: 0, ySplit: 2 };
      XLSXStyle.utils.book_append_sheet(workbook, ws, "Detalle CXP");
    }

    XLSXStyle.writeFile(workbook, `Flujo_Tesorefia_${moment().format("DD-MM-YYYY")}.xlsx`);
  }

  descargarPdf() {
    pdfMake
      .createPdf(reporteDeFlujoDeTesorefiaPdf(this.state.dataReporte))
      .download(`Flujo_Tesorefia_${moment().locale("es").format("L")}`);
  }

  buildChartSVG(dias) {
    const diasProy = dias.filter((d) => d.fecha !== "VENCIDAS");
    if (diasProy.length === 0) return null;

    const W = 720, H = 240;
    const pad = { t: 15, r: 15, b: 55, l: 75 };
    const cW = W - pad.l - pad.r;
    const cH = H - pad.t - pad.b;
    const n  = diasProy.length;

    const maxV = Math.max(
      ...diasProy.flatMap((d) => [d.porCobrar || 0, d.porPagar || 0, Math.abs(d.saldoFinal || 0)]),
      1
    );

    const groupW = cW / n;
    const barW   = Math.max(2, Math.min(groupW * 0.36, 14));
    const sy     = (v) => cH - Math.max(0, Math.min(1, (v || 0) / maxV)) * cH;

    const fmtK = (v) => {
      const a = Math.abs(v);
      if (a >= 1e6) return `$${(a / 1e6).toFixed(1)}M`;
      if (a >= 1e3) return `$${(a / 1e3).toFixed(0)}k`;
      return `$${a.toFixed(0)}`;
    };

    let grid = "", bars = "", lineEl = "", xlabels = "";

    for (let i = 0; i <= 4; i++) {
      const y = (i / 4) * cH;
      grid += `<line x1="0" y1="${y.toFixed(1)}" x2="${cW}" y2="${y.toFixed(1)}" stroke="#EEEEEE" stroke-width="1"/>`;
      grid += `<text x="-6" y="${(y + 4).toFixed(1)}" text-anchor="end" font-size="10" fill="#888" font-family="Arial,sans-serif">${fmtK(maxV * (1 - i / 4))}</text>`;
    }
    grid += `<line x1="0" y1="0" x2="0" y2="${cH}" stroke="#CCCCCC" stroke-width="1"/>`;
    grid += `<line x1="0" y1="${cH}" x2="${cW}" y2="${cH}" stroke="#CCCCCC" stroke-width="1"/>`;

    const linePs = [];
    const xStep  = Math.max(1, Math.ceil(n / 12));

    diasProy.forEach((d, i) => {
      const gx   = i * groupW;
      const midX = gx + groupW / 2;

      const cobH = Math.max(0, ((d.porCobrar || 0) / maxV) * cH);
      if (cobH > 0.5)
        bars += `<rect x="${(gx + groupW * 0.08).toFixed(1)}" y="${(cH - cobH).toFixed(1)}" width="${barW.toFixed(1)}" height="${cobH.toFixed(1)}" fill="#52C41A" rx="2"/>`;

      const pagH = Math.max(0, ((d.porPagar || 0) / maxV) * cH);
      if (pagH > 0.5)
        bars += `<rect x="${(gx + groupW * 0.54).toFixed(1)}" y="${(cH - pagH).toFixed(1)}" width="${barW.toFixed(1)}" height="${pagH.toFixed(1)}" fill="#FF4D4F" rx="2"/>`;

      linePs.push({ x: midX.toFixed(1), y: sy(d.saldoFinal).toFixed(1) });

      if (i % xStep === 0) {
        const lx = midX.toFixed(1);
        const ly = (cH + 14).toFixed(1);
        xlabels += `<text x="${lx}" y="${ly}" text-anchor="end" font-size="9" fill="#666" font-family="Arial,sans-serif" transform="rotate(-40,${lx},${ly})">${moment(d.fecha, "YYYY-MM-DD").format("DD/MM")}</text>`;
      }
    });

    if (linePs.length > 1) {
      const pathD = linePs.map((p, i) => `${i === 0 ? "M" : "L"}${p.x},${p.y}`).join(" ");
      lineEl  = `<path d="${pathD}" stroke="#1890FF" stroke-width="2.5" fill="none" stroke-linejoin="round" stroke-linecap="round"/>`;
      lineEl += linePs.map((p) => `<circle cx="${p.x}" cy="${p.y}" r="2.5" fill="#1890FF" stroke="white" stroke-width="1"/>`).join("");
    }

    const lx0 = pad.l;
    const legendY = H - 10;
    const legend = `
      <rect x="${lx0}" y="${legendY - 10}" width="12" height="12" fill="#52C41A" rx="2"/>
      <text x="${lx0 + 16}" y="${legendY}" font-size="10" fill="#333" font-family="Arial,sans-serif">Por Cobrar (CXC)</text>
      <rect x="${lx0 + 148}" y="${legendY - 10}" width="12" height="12" fill="#FF4D4F" rx="2"/>
      <text x="${lx0 + 164}" y="${legendY}" font-size="10" fill="#333" font-family="Arial,sans-serif">Por Pagar (CXP)</text>
      <line x1="${lx0 + 294}" y1="${legendY - 5}" x2="${lx0 + 312}" y2="${legendY - 5}" stroke="#1890FF" stroke-width="2.5"/>
      <circle cx="${lx0 + 303}" cy="${legendY - 5}" r="3" fill="#1890FF"/>
      <text x="${lx0 + 318}" y="${legendY}" font-size="10" fill="#333" font-family="Arial,sans-serif">Saldo Final Proyectado</text>`;

    return `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="${W}" height="${H}">
  <rect width="${W}" height="${H}" fill="white"/>
  <g transform="translate(${pad.l},${pad.t})">
    ${grid}${bars}${lineEl}${xlabels}
  </g>
  ${legend}
</svg>`;
  }

  svgAPng(svgStr, w, h) {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement("canvas");
      canvas.width  = w * 2; // retina
      canvas.height = h * 2;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.scale(2, 2);
      const img = new Image();
      const blob = new Blob([svgStr], { type: "image/svg+xml;charset=utf-8" });
      const url  = URL.createObjectURL(blob);
      img.onload = () => {
        ctx.drawImage(img, 0, 0, w, h);
        URL.revokeObjectURL(url);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = reject;
      img.src = url;
    });
  }

  async descargarPdfGerencial() {
    this.setState({ loading: true });
    try {
      const svgStr  = this.buildChartSVG(this.state.diasFlujo);
      const chartPng = svgStr ? await this.svgAPng(svgStr, 720, 240) : null;
      pdfMake
        .createPdf(reporteFlujoDeTesorefiaPresentacionPdf(this.state.dataReporte, chartPng))
        .download(`Flujo_Tesorefia_Gerencial_${moment().format("DD-MM-YYYY")}`);
    } catch (e) {
      message.error("No se pudo generar la presentación gerencial");
    }
    this.setState({ loading: false });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const { bancos, diasFlujo, dataReporte, dataGrafico, loading } = this.state;

    const saldoTotal = bancos.reduce((sum, b) => sum + (b.saldo || 0), 0);
    const totalCobrar = dataReporte?.totales?.totalPorCobrar || 0;
    const totalPagar = dataReporte?.totales?.totalPorPagar || 0;
    const saldoFinalProyectado = dataReporte?.totales?.saldoFinalProyectado || 0;

    const columnsDias = [
      {
        title: "Fecha",
        dataIndex: "fecha",
        key: "fecha",
        render: (v) =>
          v === "VENCIDAS" ? (
            <Tag color="volcano" style={{ fontWeight: 700 }}>Vencidas anteriores</Tag>
          ) : (
            moment(v, "YYYY-MM-DD").format("DD/MM/YYYY")
          ),
        width: 150,
        ellipsis: true,
      },
      {
        title: "Saldo Inicial",
        dataIndex: "saldoInicial",
        key: "saldoInicial",
        render: (v) => dineroDisabledMask(v),
        align: "right",
        ellipsis: true,
      },
      {
        title: "Por Cobrar (CXC)",
        dataIndex: "porCobrar",
        key: "porCobrar",
        render: (v) => (
          <span style={{ color: v > 0 ? "#389e0d" : "inherit", fontWeight: v > 0 ? 600 : "normal" }}>
            {dineroDisabledMask(v)}
          </span>
        ),
        align: "right",
        ellipsis: true,
      },
      {
        title: "Por Pagar (CXP)",
        dataIndex: "porPagar",
        key: "porPagar",
        render: (v) => (
          <span style={{ color: v > 0 ? "#cf1322" : "inherit", fontWeight: v > 0 ? 600 : "normal" }}>
            {dineroDisabledMask(v)}
          </span>
        ),
        align: "right",
        ellipsis: true,
      },
      {
        title: "Saldo Final",
        dataIndex: "saldoFinal",
        key: "saldoFinal",
        render: (v) => (
          <span style={{ fontWeight: 700, color: v >= 0 ? "#1890ff" : "#cf1322" }}>
            {dineroDisabledMask(v)}
          </span>
        ),
        align: "right",
        ellipsis: true,
      },
    ];

    const columnsCxc = [
      { title: "Cliente", dataIndex: "clienteNombre", key: "clienteNombre", ellipsis: true },
      { title: "Folio", dataIndex: "folio", key: "folio", width: 100 },
      {
        title: "Monto",
        dataIndex: "monto",
        key: "monto",
        align: "right",
        render: (v) => <span style={{ color: "#389e0d", fontWeight: 600 }}>{dineroDisabledMask(v)}</span>,
      },
      {
        title: "Estado",
        dataIndex: "diasVencido",
        key: "diasVencido",
        align: "center",
        width: 110,
        render: (v) => (
          <Tag color={v <= 0 ? "green" : v <= 30 ? "orange" : "red"}>
            {v <= 0 ? "Al día" : `${v} días vencido`}
          </Tag>
        ),
      },
    ];

    const columnsCxp = [
      { title: "Proveedor", dataIndex: "proveedorNombre", key: "proveedorNombre", ellipsis: true },
      { title: "Folio", dataIndex: "folio", key: "folio", width: 100 },
      {
        title: "Monto",
        dataIndex: "monto",
        key: "monto",
        align: "right",
        render: (v) => <span style={{ color: "#cf1322", fontWeight: 600 }}>{dineroDisabledMask(v)}</span>,
      },
      {
        title: "Estado",
        dataIndex: "diasVencido",
        key: "diasVencido",
        align: "center",
        width: 110,
        render: (v) => (
          <Tag color={v <= 0 ? "green" : v <= 30 ? "orange" : "red"}>
            {v <= 0 ? "Al día" : `${v} días vencido`}
          </Tag>
        ),
      },
    ];

    const expandedRowRender = (record) => {
      const hasCxc = record.cxcDetalle?.length > 0;
      const hasCxp = record.cxpDetalle?.length > 0;
      if (!hasCxc && !hasCxp) {
        return <p style={{ margin: "8px 0", color: "#aaa", textAlign: "center" }}>Sin movimientos pendientes este día</p>;
      }
      return (
        <div style={{ padding: "8px 16px" }}>
          {hasCxc && (
            <>
              <p style={{ margin: "0 0 6px 0", fontWeight: 700, color: "#389e0d", fontSize: 13 }}>
                <ArrowUpOutlined /> Cuentas por Cobrar
              </p>
              <TableItem
                columns={columnsCxc}
                dataSource={record.cxcDetalle}
                size="small"
                pagination={false}
                rowKey={(r, i) => `cxc-${i}`}
              />
            </>
          )}
          {hasCxc && hasCxp && <Divider style={{ margin: "10px 0" }} />}
          {hasCxp && (
            <>
              <p style={{ margin: "0 0 6px 0", fontWeight: 700, color: "#cf1322", fontSize: 13 }}>
                <ArrowDownOutlined /> Cuentas por Pagar
              </p>
              <TableItem
                columns={columnsCxp}
                dataSource={record.cxpDetalle}
                size="small"
                pagination={false}
                rowKey={(r, i) => `cxp-${i}`}
              />
            </>
          )}
        </div>
      );
    };

    return (
      <>
        <Form
          ref={this.formRef}
          name="reporteFlujoDeTesorefia"
          onFinish={this.consultarReporte.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            fechaFinal: moment().add(30, "days"),
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Flujo de Efectivo — Tesorería"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <Space>
                {dataReporte && (
                  <ButtonItem
                    blanco
                    onClick={() => this.descargarExcel()}
                    icon={<FileExcelOutlined />}
                  >
                    Descargar Excel
                  </ButtonItem>
                )}
                {dataReporte && (
                  <ButtonItem
                    blanco
                    onClick={() => this.descargarPdf()}
                    icon={<FilePdfOutlined />}
                  >
                    Descargar PDF
                  </ButtonItem>
                )}
                {dataReporte && (
                  <ButtonItem
                    type="primary"
                    onClick={() => this.descargarPdfGerencial()}
                    icon={<FundProjectionScreenOutlined />}
                    style={{ background: "#007A8A", borderColor: "#007A8A" }}
                  >
                    Presentación Gerencial
                  </ButtonItem>
                )}
                <ButtonItem type="primary" htmlType="submit">
                  Consultar
                </ButtonItem>
              </Space>
            }
          />

          <Spin spinning={loading}>
            {/* Filtros */}
            <div
              style={{
                backgroundColor: "white",
                padding: "16px 20px",
                borderRadius: 8,
                marginBottom: 10,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                display: "flex",
                gap: 24,
                alignItems: "flex-end",
              }}
            >
              <FormItem label="Fecha Final" name="fechaFinal" required marginBottom="0px">
                <DatePickerItem
                  disabledDate={(current) =>
                    current && current.isSameOrBefore(moment(), "day")
                  }
                />
              </FormItem>
            </div>

            {/* Cards de bancos */}
            {bancos.length > 0 && (
              <Row gutter={[12, 12]} style={{ marginBottom: 10 }}>
                {bancos.map((banco) => (
                  <Col xs={24} sm={12} md={8} lg={6} key={banco._id}>
                    <Card
                      size="small"
                      style={{
                        borderRadius: 8,
                        boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                        borderLeft: "4px solid #00BFD6",
                        height: "100%",
                      }}
                    >
                      <Statistic
                        title={
                          <span style={{ fontSize: 12 }}>
                            <BankOutlined style={{ marginRight: 5, color: "#00BFD6" }} />
                            {banco.banco} — {banco.nombre}
                          </span>
                        }
                        value={round2Decimals(banco.saldo)}
                        precision={2}
                        prefix="$"
                        suffix={<span style={{ fontSize: 12, color: "#888" }}>{banco.moneda}</span>}
                        valueStyle={{ fontSize: 18, color: banco.saldo >= 0 ? "#262626" : "#cf1322" }}
                      />
                    </Card>
                  </Col>
                ))}
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Card
                    size="small"
                    style={{
                      borderRadius: 8,
                      boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                      borderLeft: "4px solid #52c41a",
                      background: "#f6ffed",
                      height: "100%",
                    }}
                  >
                    <Statistic
                      title={
                        <span style={{ fontSize: 12 }}>
                          <WalletOutlined style={{ marginRight: 5, color: "#52c41a" }} />
                          Total en Bancos
                        </span>
                      }
                      value={round2Decimals(saldoTotal)}
                      precision={2}
                      prefix="$"
                      valueStyle={{ fontSize: 20, fontWeight: 700, color: "#237804" }}
                    />
                  </Card>
                </Col>
              </Row>
            )}

            {/* Resumen del período */}
            {dataReporte && (
              <Row gutter={[12, 12]} style={{ marginBottom: 10 }}>
                <Col xs={24} sm={8}>
                  <Card
                    size="small"
                    style={{ borderRadius: 8, boxShadow: "0 4px 14px rgba(0,0,0,0.08)", textAlign: "center" }}
                  >
                    <Statistic
                      title="Total Por Cobrar en el Período"
                      value={round2Decimals(totalCobrar)}
                      precision={2}
                      prefix="$"
                      valueStyle={{ color: "#389e0d" }}
                      suffix={<ArrowUpOutlined style={{ fontSize: 14 }} />}
                    />
                  </Card>
                </Col>
                <Col xs={24} sm={8}>
                  <Card
                    size="small"
                    style={{ borderRadius: 8, boxShadow: "0 4px 14px rgba(0,0,0,0.08)", textAlign: "center" }}
                  >
                    <Statistic
                      title="Total Por Pagar en el Período"
                      value={round2Decimals(totalPagar)}
                      precision={2}
                      prefix="$"
                      valueStyle={{ color: "#cf1322" }}
                      suffix={<ArrowDownOutlined style={{ fontSize: 14 }} />}
                    />
                  </Card>
                </Col>
                <Col xs={24} sm={8}>
                  <Card
                    size="small"
                    style={{ borderRadius: 8, boxShadow: "0 4px 14px rgba(0,0,0,0.08)", textAlign: "center" }}
                  >
                    <Statistic
                      title="Saldo Final Proyectado"
                      value={round2Decimals(saldoFinalProyectado)}
                      precision={2}
                      prefix="$"
                      valueStyle={{
                        color: saldoFinalProyectado >= saldoTotal ? "#1890ff" : "#cf1322",
                        fontWeight: 700,
                      }}
                    />
                  </Card>
                </Col>
              </Row>
            )}

            {/* Gráfica */}
            {dataGrafico.length > 0 && (
              <div
                style={{
                  backgroundColor: "white",
                  padding: 20,
                  paddingBottom: 40,
                  marginBottom: 10,
                  height: 420,
                  borderRadius: 8,
                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                }}
              >
                <h2 style={{ fontSize: 15, margin: "0 0 10px 0", fontWeight: 700, color: "#262626" }}>
                  Proyección Diaria de Tesorería
                </h2>
                <ResponsiveBar
                  data={dataGrafico}
                  keys={["Por Cobrar", "Por Pagar", "Saldo Final"]}
                  indexBy="Fecha"
                  valueFormat={(e) => dineroDisabledMask(Math.abs(e))}
                  margin={{ top: 10, right: 20, bottom: 90, left: 110 }}
                  padding={0.25}
                  innerPadding={2}
                  groupMode="grouped"
                  valueScale={{ type: "linear" }}
                  indexScale={{ type: "band", round: true }}
                  colors={["#52c41a", "#ff4d4f", "#1890ff"]}
                  colorBy="id"
                  borderRadius={4}
                  borderColor={{ from: "color", modifiers: [["darker", 1.3]] }}
                  axisTop={null}
                  axisRight={null}
                  axisBottom={{
                    tickSize: 5,
                    tickPadding: 8,
                    tickRotation: 45,
                    tickValues: dataGrafico
                      ?.map((d) => d.Fecha)
                      ?.filter((_, i) => i % Math.max(1, Math.ceil(dataGrafico.length / 15)) === 0),
                  }}
                  axisLeft={{
                    tickSize: 5,
                    tickPadding: 8,
                    tickRotation: 0,
                    format: (v) => dineroDisabledMask(Math.abs(v)),
                  }}
                  enableGridX={false}
                  enableLabel={false}
                  isInteractive
                  tooltip={({ id, value, indexValue, color }) => (
                    <div
                      style={{
                        padding: 10,
                        background: "white",
                        border: "1px solid rgba(0,0,0,0.08)",
                        borderRadius: 10,
                        boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
                        minWidth: 180,
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                        <span style={{ width: 10, height: 10, borderRadius: 999, background: color, display: "inline-block" }} />
                        <strong style={{ fontSize: 13 }}>{indexValue}</strong>
                      </div>
                      <div style={{ fontSize: 13 }}>
                        {id}: <strong>{dineroDisabledMask(Math.abs(value))}</strong>
                      </div>
                    </div>
                  )}
                  legends={[
                    {
                      dataFrom: "keys",
                      anchor: "bottom",
                      direction: "row",
                      translateY: 72,
                      itemWidth: 130,
                      itemHeight: 18,
                      itemsSpacing: 10,
                      symbolSize: 10,
                      symbolShape: "circle",
                      itemOpacity: 0.85,
                      effects: [{ on: "hover", style: { itemOpacity: 1 } }],
                    },
                  ]}
                />
              </div>
            )}

            {/* Tabla detallada por día */}
            {diasFlujo.length > 0 && (
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: 8,
                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                  overflow: "hidden",
                  marginBottom: 10,
                }}
              >
                <div style={{ padding: "16px 20px 8px" }}>
                  <h2 style={{ fontSize: 15, margin: 0, fontWeight: 700 }}>Detalle por Día</h2>
                  <p style={{ color: "#888", margin: "2px 0 0", fontSize: 12 }}>
                    Expande un día para ver el detalle de CXC y CXP
                  </p>
                </div>
                <TableItem
                  columns={columnsDias}
                  dataSource={diasFlujo}
                  rowKey="fecha"
                  size="small"
                  pagination={false}
                  onRow={(record) =>
                    record.fecha === "VENCIDAS"
                      ? { style: { background: "#fff7e6", borderLeft: "4px solid #fa8c16" } }
                      : {}
                  }
                  expandable={{
                    expandedRowRender,
                    rowExpandable: (r) => r.cxcDetalle?.length > 0 || r.cxpDetalle?.length > 0,
                  }}
                />
              </div>
            )}
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ReporteFlujoDeTesorefia);
